export enum ChannelItemType {
    system = 0,
    email = 1,
    message = 2,
    call = 3,
    voicemail = 4,
    submit = 5,
    click = 6,
}
